// Shared presentation helpers for the org usage / insights dashboards.

// Compact token count: 1.2M / 3.4K / 950.
export const formatTokens = (n) => {
  if (n >= 1e6) {
    return `${(n / 1e6).toFixed(1)}M`
  }
  if (n >= 1e3) {
    return `${(n / 1e3).toFixed(1)}K`
  }

  return String(n || 0)
}

// Bar width as a percentage of the max (min 2% so a tiny value is still visible).
export const barWidth = (value, max) => `${Math.max(2, Math.round((value / max) * 100))}%`
